import { DBRoleConstants } from '../../_constants';
import { DBRoleService } from '../../_services';
import { alertActions } from '../alertActions';

export const DBRoleActions = {
    getAllDBRole,
};

function fetched() { return { type: DBRoleConstants.FETCHED } }
function fetching() { return { type: DBRoleConstants.FETCHING } }

function getAllDBRole() {
    return dispatch => {
        dispatch(fetching());

        DBRoleService.getAllDBRole()
            .then(
                DBRole => {
                    dispatch(success(DBRole))
                    dispatch(fetched());
                },
                error => {
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(DBRole) { return { type: DBRoleConstants.GET_DBROLE, DBRole } }
}

